import { render, staticRenderFns } from "./CreateDTE.vue?vue&type=template&id=e1fd98b4&scoped=true&"
import script from "./CreateDTE.vue?vue&type=script&lang=js&"
export * from "./CreateDTE.vue?vue&type=script&lang=js&"
import style0 from "./CreateDTE.vue?vue&type=style&index=0&id=e1fd98b4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e1fd98b4",
  null
  
)

export default component.exports